<template>
  <div class="app"> 
    <div class="goldusers-details">
      <div class="header header-register">
         <img src="../assets/images/arrow-w.svg" @click="goBack()" />
          <h1>{{$t('registration')}}</h1>
       </div>
      <div class="register-frm">
          <div class="usersdetails">
            <span class="bankdetail">{{$t('consumerdetail')}}</span>
            <div class="input_detail">
              <div class="form-group">
                <label class>{{$t('username')}}*</label>
                <input
                  type="text"
                  :placeholder="$t('username')"
                  class="input"
                  v-model="user.user_name"
                />
              </div>
            </div>
            <div class="input_detail">
              <div class="form-group">
                <label class>{{$t('phone_no')}}*</label>
                <input
                  type="number"
                  :placeholder="$t('phone_no')"
                  :disabled="true"
                  class="input"
                  v-model="user.mobile_no"
                />
              </div>
            </div>
          </div>
        
        <div class="formdetails">
          <div class="usersdetails">
            <div class="input_detail">
              <div class="form-group">
                <label class>{{$t('pincode')}}*</label>
                <input
                  type="text"
                  :placeholder="$t('pincode')"
                  class="input"
                  v-model="user.pincode"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="formdetails border">
          <div class="usersdetails">
            <span class="bankdetail">Privacy Details</span>
            <div class="input_detail">
              <div class="form-group">
                <label class>{{$t('aaddhar_no')}}*</label>
                <input
                  type="number"
                  :placeholder="$t('aaddhar_no')"
                  class="input"
                  v-model="user.aadhar_no"
                />
              </div>
            </div>
            <div class="input_detail">
              <div class="form-group">
                <label class>{{$t('pan_number')}}*</label>
                <input
                  type="text"
                  :placeholder="$t('pan_number')"
                  class="input text-transform"
                  v-model="user.pan_no"
                  style="{'text-transform': uppercase}"
                />
              </div>
            </div>
          </div>
          <div class="checked-btn">
            <label class="radio-btn left">
              <input type="radio" v-model="payType" value="bank" checked name="radio2"
                @click="handleRadio"/> {{$t('bank')}}
              <span class="circle"></span>
            </label>
            <label class="radio-btn">
              <input  type="radio" v-model="payType" value="upi"  checked name="radio2"
                @click="handleRadio" />UPI
              <span class="circle"></span>
            </label>
          </div>
          <div class="usersdetails">
            <div class="input_detail" v-if="isRadioToggle">
              <div class="form-group">
                <label class>{{$t('account_name')}}*</label>
                <input type="text" :placeholder="$t('account_name')"
                  class="input"
                  v-model="user.bank_holder_name"
                />
              </div>
            </div>
            <div class="input_detail" v-if="isRadioToggle">
              <div class="form-group">
                <label class>{{$t('bankaccount')}}*</label>
                <input
                  type="number"
                  :placeholder="$t('bankaccount')"
                  class="input"
                  v-model="user.bank_account"
                />
              </div>
            </div>
            <div class="input_detail" v-if="isRadioToggle">
              <div class="form-group">
                <label class>{{$t('re_bank_aacount')}}*</label>
                <input
                  type="password"
                  :placeholder="$t('re_bank_aacount')"
                  class="input"
                  v-model="user.re_bank_account"
                />
              </div>
            </div>
            <div class="input_detail" v-if="isRadioToggle">
              <div class="form-group">
                <label class>{{$t('ifsc_code')}}*</label>
                <input
                  type="text"
                  :placeholder="$t('ifsc_code')"
                  class="input"
                  v-model="user.ifsc_code"
                />
              </div>
            </div>
            <div class="input_detail" v-if="!isRadioToggle">
              <div class="form-group">
                <label class>UPI*</label>
                <input
                  type="text"
                  :placeholder="$t('upicode')"
                  class="input"
                  v-model="user.upi_address"
                />
              </div>
            </div>
            <input type="checkbox" v-model="tc" />
            <a
              href="https://cdn.mall91.com/b6a5d35c-7ca0-4d53-9bcd-854f2c57b4f7.pdf"
            >{{$t('acceptterms')}}</a>
            <div class="submit-btn" @click="registerUser">{{$t('submit')}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>

import { toaster, validateRegistrationForm } from "../utils/helper";
import {
  isName,
  isMobileNumber,
  isPinCodeNumber,
  isAadhaarCardNumber,
  isPanCardNumber,
  isBankAccountNumber,
  isIfscCode,
  isEmail,
  isUpiCode
} from "../utils/validators";
export default {
  components: {
    
  },
  data() {
    return {
      isRadioToggle: false,
      payType: "upi",
      tc: false,
      user: {
        mobile_no: this.$store.state.userDetail.phone_number,
        user_name: "",
        pincode: "",
        pan_no: "",
        aadhar_no: "",
        ifsc_code: "",
        upi_address: "",
        bank_account: "",
        re_bank_account: "",
        bank_holder_name: ""
      },
      loading: false
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    handleRadio() {
      this.isRadioToggle = !this.isRadioToggle;
    },

    registerUser() {
      const isValid = validateRegistrationForm(this, this.payType);
      if (isValid) {
        this.loading = !this.loading;
        this.$store
          .dispatch({
            type: "saveUser",
            payload: this.user
          })
          .then(data => {
            this.loading = !this.loading;
            if (data.data.success) {
              this.$router.push("/");
            }
          })
          .catch(err => {
            this.loading = !this.loading;
          });
      }
    }
  },
};
</script>